import { Component, Prop, Vue } from 'nuxt-property-decorator';
import * as VueGoogleMaps from 'vue2-google-maps';
// @ts-ignore
import GmapMap from 'vue2-google-maps/src/components/map.vue';

const gmapStyles = require('./gmapStyles.json');

@Component<MissionMap>({
  inheritAttrs: false,
  components: {
    GmapMap,
  },
  data(config: any) {
    return {
      API_KEY: config.gmapsApiKey,
    };
  }
})
export default class MissionMap extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  options!: google.maps.MapOptions;

  @Prop({ type: Boolean, default: false })
  zoomControl!: false;

  get mapOptions() {
    return {
      clickableIcons: false,
      disableDefaultUI: true,
      zoomControl: this.zoomControl,
      disableDoubleClickZoom: true,
      gestureHandling: 'greedy',
      styles: gmapStyles,
      ...this.options,
    };
  }
}

export function registerMissionMap(config: any) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: config.gmapsApiKey,
      libraries: config.gmapsApiLibraries,
    },
    installComponents: false,
  });
}
